import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/home/Home'
import Pptra from '../components/pptra/Index'
import NotFound from '../components/NotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { title: 'Arlington County - Tax Estimators' }
    },
    {
      path: '/vpp',
      name: 'vpp',
      component: Pptra,
      meta: { title: 'Arlington County - Vehicle Personal Property Tax Estimator' }
    },
    {
      path: '*',
      name: '404',
      component: NotFound,
      meta: { title: 'Arlington County - Page not found' }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const defaultTitle = 'Arlington County - Tax Estimator';
  document.title = to.meta.title || defaultTitle;
  next();
});

function trackPageView(to) {
  const send = () => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: to.fullPath,
        page_title: to.meta.title || document.title,
        page_location: window.location.href
      });
    } else {
      console.warn('gtag not ready. Skipping pageview.');
    }
  };

  setTimeout(send, 200); 
}

router.afterEach((to) => {
  trackPageView(to);
});

export default router;

